import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 214.96 130.17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M84.49 129.63c-12.25-3.17-12.94-18.69 2.88-29.08 15.73-10.44 37.12-10.31 45.14 5.86-10.09-3.73-16.21-5.7-21.63 4.67-5.43 10.38-14.24 21.72-26.39 18.56m-33.43-2.6c7.71-6.31 10.25-6.73 19.94-21.37 9.69-14.64 30.24-36.3 42.95-43.87 12.73-7.56 24.81-10.09 38.7-12.84l20.42-4.13c-3.09 20.07-18.48 30.31-39.88 32.78-21.3 2.54-37.79 7.15-48.3 19.33L66.8 117.7c-4.33 5.02-9.69 8.11-15.74 9.34M32.8 47.78l3.92-16.63c1.16-3.51 4.06-5.78 8.46-5.64l13.47.34c4.88.14 7.76 5.71 6.61 11.21l-.97 6.45c-.95 6.88-5.14 11.82-12.16 14.93-28.75 9.9-48.54 23.03-45.51 45.17 3.02 22.19 36.64 24.81 55.54-1.72l43.85-61.54c16.36-22.95 41.11-33.4 70.05-36.76L214.96 0c-6.45 21.32-20.21 36.1-41.37 40.02-36.78 6.74-63.77 14.16-78.57 31.07l-14.1 16.3-21.24 26.53c-9.54 11.89-23.38 16.22-38.9 13.39C7.1 124.23-.88 115.22.08 96.19 1.04 77.14 14.6 56.1 32.8 47.78",
      style: {"fill":"#004846","fill-rule":"evenodd"}
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "W5-logo"}) } }